// frontend/src/utils/axios.js
import axios from "axios";

// Determine the base URL based on the environment
const getBaseURL = () => {
  // Check if we're running on localhost
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  ) {
    // Use local backend for development
    return "http://localhost:5000";
  }

  // Use production backend for deployed app
  return "https://webvenlymarketingbackend-661910166329.us-east1.run.app";
};

const instance = axios.create({
  baseURL: getBaseURL(),
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor for debugging (optional)
instance.interceptors.request.use(
  (config) => {
    console.log(
      `API Request: ${config.method?.toUpperCase()} ${config.baseURL}${
        config.url
      }`
    );
    return config;
  },
  (error) => {
    console.error("Request error:", error);
    return Promise.reject(error);
  }
);

// Add a response interceptor for better error handling (optional)
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // Server responded with error status
      console.error(`API Error ${error.response.status}:`, error.response.data);

      // Handle specific error cases
      if (error.response.status === 404) {
        console.error(
          "API endpoint not found. Check if backend is deployed and route exists."
        );
      } else if (error.response.status === 500) {
        console.error("Server error. Check backend logs.");
      }
    } else if (error.request) {
      // Request made but no response
      console.error("No response from server. Check if backend is running.");
    } else {
      // Something else happened
      console.error("Request setup error:", error.message);
    }

    return Promise.reject(error);
  }
);

// Export the instance
export default instance;

// Also export the base URL for reference
export const API_BASE_URL = getBaseURL();
